export default __webpack_public_path__ + "static/media/kitchen3-afterG-1440w.3cf806de.avif";